const data = {
  'Home.message': "It's a beautiful day outside.",
  'home.beauty_advisor': 'Beauty Advisor',
  'home.virtual_mirror': 'Virtual Mirror',
  'home.lens_find': 'Примерить онлайн',
  'home.lens_continue': 'Нажмите, чтобы продолжить',
  'home.quiz_find': 'Find my persona',
  'home.logout': 'Logout',
  'home.let_us_find': 'Let us find the',
  'home.look_for_you': 'look for you',
  'home.try_a_lens': 'Try a lens',
  'home.color': 'color',
  'without_quiz.lens_color': 'Try a lens color',
  'without_quiz.access_cam': 'Необходим доступ к камере',
  'without_quiz.access_cam_sub_text': 'для онлайн примерки',
  'without_image.img_confirm': 'Are you sure you want to use this image?',
  'without_image.Allow': 'Не разрешать',
  'without_image.OK': 'Разрешить',
  'dba.find_look': 'Let us find the look for you',
  'dba.about_urself': 'Tell us more about yourself',
  'dba.trydba': 'Try the DBA App',
  'dba.next': 'Next',
  'dba.Currently wearing:': 'Currently wearing:',
  'quiz.skin_color': 'What is your skin tone color?',
  'quiz.hair_Color': 'What is your hair color?',
  'menu.home': 'Home',
  'menu.bye': 'Bye',
  'menu.share': 'Share',
  'menu.save': 'Save',
  'menu.trail': 'Free trial',
  'menu.find': 'Find Doctor',
  'menu.product': 'Product Info',
  'lens.bright': 'Radiant Bright™',
  'lens.shine': 'Natural Shine™',
  'lens.charm': 'Radiant Charm™',
  'lens.chic': 'Radiant Chic™',
  'lens.sweet': 'Radiant Sweet™',
  'lens.vivid': 'Vivid Style',
  'lens.accent': 'Accent Style',
  'footer.care': 'About Lens Care',
  'footer.products': 'About Products',
  'footer.legal': 'Правила и условия/Официальное уведомление',
  'footer.acuvue': 'О 1-DAY ACUVUE<sup>®</sup> DEFINE<sup>®</sup>',
  'footer.contact': 'Свяжитесь с нами',
  'footer.privacy': 'Политика конфиденциальности',
  'footer.cookiePolicy':'Политика использования файлов cookie',
  'footer.label': 'About',
  'footer.makeup': 'Makeup Tutorial',
  'login.email': 'E-mail',
  'login.password': 'Password',
  'login.submit': 'Submit',
  'nav.welcome_guest': 'Welcome Guest',
  'vm.currently_wearing': 'Currently Wearing',
  'vm.rec_variant': 'Recommended Variant',
  'product_info.about': 'О НАШИХ ЛИНЗАХ',
  'lens.now': 'Now',
  'tabs.classic_lenses': 'Define Classic',
  'tabs.fresh_lenses': 'Выбрать линзы',
  'tabs.looks': 'Looks',
  'tabs.makeup': 'Выбрать макияж',
  'tabs.insertion': '',
  'tabs.removal': '',
  'tooltip.home': 'Главная',
  'tooltip.ba': 'Beauty Advisor',
  'tooltip.care': 'Lens Care',
  'tooltip.more': 'More Options',
  'tooltip.buy': 'Buy',
  'tooltip.share': 'Share',
  'tooltip.trial': 'Free Trial',
  'tooltip.ecp': 'Find ECP',
  'tooltip.logout': 'Logout',
  'tooltip.vm': 'Virtual Try On',
  'modal.share': 'Share',
  'modal.buy': 'Buy',
  'modal.free_trial': 'Free Trial',
  'modal.shop_now': 'Shop Now',
  'modal.go': 'Go',
  'looks.downloadPdf': 'Download Tutorial',
  'guides.how_to_put_on_lens': '',
  'guides.how_to_remove_lens': '',
  'looks.you_have_selected': 'You have selected: ',
  'tutorials.or': 'OR',
  'tutorials.scan': 'Scan QR code to download',
  'tutorials.product_unavailable': 'This product is currently unavailable in this market.',
  'tutorials.look': 'Look ',
  'products.disclaimer_header': '',
  'tutorials.purchase': 'Buy online',
  'tutorials.lens': 'Lens',
  'looks.best_suited': 'look is best suited with',
  'looks.product_unavailable': 'Not Available',
  'looks.you_have_chosen': 'ВЫ ВЫБРАЛИ',
  'looks.with_lens': 'With Lens:',
  'looks.with_looks': 'With Looks:',
  'modal.buy_button': 'НАЙТИ ОПТИКУ',
  'permissions.allow_look_removal': 'This action would remove applied look',
  'permissions.allow_makeup_removal': 'This action would remove applied makeup',
  'permissions.allow_look_removal_sub_text': 'Do you want to proceed?',
  'tabs.pls_select_look': 'Please select a look',
  'tabs.pls_select_lens': 'Please select a lens',
  'tabs.pls_select_makeup_category': 'Please select a makeup category',
  'button.value_try_the': 'Примерить',
  'button.heading_try_the': 'онлайн',
  'button.value_find_your': 'Find Your',
  'button.heading_find_your': 'Persona',
  'button.value_price': '$20',
  'button.heading_price': 'Reward',
  'products.external_buy': 'НАЙТИ ОПТИКУ',
  'product.browser-alert' : 'Лучше всего эффект будет виден при ярком естественном освещении.',
  'LastUpdate' : 'Последнее обновление:',
};
export default data;
